import PortalLayout from "../layouts/portalLayout.jsx";

var indexRoutes = [
  { path: "/me", name: "PatientPortal", component: PortalLayout },
];

export default indexRoutes;
